import { PreparedWorkload } from 'features/workload-optimization';
import { useIsWoopDemoMode } from 'features/workload-optimization/hooks/useIsWoopDemoMode';

import { usePermitEditWorkload } from '../../_hooks/permissions/usePermitEditWorkload';
import { canEditWorkload } from '../../_utils';

export const useCanEditWorkloadField = (workload: PreparedWorkload) => {
  const { permitEdit } = usePermitEditWorkload();
  const isWoopDemoMode = useIsWoopDemoMode();

  return {
    canEditWorkloadField:
      permitEdit && !isWoopDemoMode && canEditWorkload(workload),
  };
};
